// extracted by mini-css-extract-plugin
export var bannerImage = "GetInTouchNew-module--bannerImage--zpwBN";
export var closeIcon = "GetInTouchNew-module--closeIcon--Wsc2B";
export var formContainer = "GetInTouchNew-module--formContainer--ODP6a";
export var formContent = "GetInTouchNew-module--formContent--NKClV";
export var formHeader = "GetInTouchNew-module--formHeader--SmLtb";
export var getInTouchWrapper = "GetInTouchNew-module--getInTouchWrapper--liSFk";
export var imageContainer = "GetInTouchNew-module--imageContainer--lMNaF";
export var mainTitle = "GetInTouchNew-module--mainTitle--HwKuS";
export var subTitle = "GetInTouchNew-module--subTitle--xTZhC";